import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { PageHead } from "./Layout";
import { EmailBranding } from "./EmailBranding";

export default function Business() {
  const [f, setF] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/orgs/me").then(({ data }) => setF({ ...data, zips: (data.service_area_zip_codes || []).join(", ") }));
  }, []);
  if (!f) return <p className="text-muted-foreground">Loading…</p>;
  const set = (k: string) => (e: any) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      await api.patch("/orgs/me", { name: f.name, notification_email: f.notification_email, phone: f.phone, website: f.website,
        service_area_note: f.service_area_note, service_area_zip_codes: f.zips.split(/[\s,]+/).filter(Boolean) });
      toast.success("Business profile saved");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const row = (k: string, label: string, props: any = {}) => (
    <div className="space-y-1.5"><Label className="text-xs" htmlFor={k}>{label}</Label><Input id={k} value={f[k] || ""} onChange={set(k)} data-testid={`business-${k}-input`} {...props} /></div>
  );
  return (
    <div className="fade-up max-w-2xl">
      <PageHead title="Business Profile" sub="Shown to homeowners in the widget and used for lead notifications." />
      <div className="bg-card border rounded-xl p-6 space-y-5">
        {row("name", "Business name")}
        {row("notification_email", "Lead notification email", { type: "email" })}
        <p className="text-[11px] text-muted-foreground -mt-3" data-testid="business-notification-note">Lead alerts go to a new address right away. It's used as the homeowner Reply-To only after you confirm it from the link we email to it.</p>
        <div className="grid sm:grid-cols-2 gap-4">{row("phone", "Phone (optional)", { type: "tel" })}{row("website", "Website (optional)", { placeholder: "https://" })}</div>
        <div className="space-y-1.5">
          <Label className="text-xs" htmlFor="zips">Service-area ZIP codes (optional)</Label>
          <Textarea id="zips" rows={3} value={f.zips} onChange={set("zips")} placeholder="80202, 80203" className="font-mono" data-testid="business-zips-input" />
          <p className="text-[11px] text-muted-foreground">If set, addresses outside these ZIPs are routed to “Request manual review” instead of an instant price.</p>
        </div>
        {row("service_area_note", "Service-area note (optional)")}
        <Button onClick={save} disabled={busy} data-testid="business-save-button">{busy ? "Saving…" : "Save"}</Button>
      </div>
      <EmailBranding />
    </div>
  );
}
